import * as retrieveCredentialsApi from '@/network/api/retrieveCredentials.api.js'

/** validates phone number
@return { promise } - validates phone number
*/
export const validatePhoneNumber = async (context, payload) => {
    const res = await retrieveCredentialsApi.validatePhoneNumber(payload)
    return res
}

/** validates phone number
@return { promise } - validates phone number
*/
export const sendValidatePhoneNumberOTP = async (context, payload) => {
    const res = await retrieveCredentialsApi.sendValidatePhoneNumberOTP(payload)
    return res
}

/** Resend OTP to phoneNumber
@return { promise }
*/
export const resendOTP = async (context, payload) => {
    const res = await retrieveCredentialsApi.resendOTP(payload)
    return res
}

/** validates personal data
@return { promise } - validates personal data
*/
export const validatePersonalData = async (context, payload) => {
    const res = await retrieveCredentialsApi.validatePersonalData(payload)
    return res
}

/** retrieve credentials
@return { promise } - retrieve credentials
*/
export const retrieveCredentials = async (context, payload) => {
    const res = await retrieveCredentialsApi.retrieveCredentials(payload)
    return res
}

/** retrieve credentials
@return { promise } - retrieve credentials
*/
export const retrieveCredentialsResend = async (context, payload) => {
    const res = await retrieveCredentialsApi.retrieveCredentialsResend(payload)
    return res
}

/** retrieve credentials
@return { promise } - retrieve credentials
*/
export const retrieveCredentialsFinish = async (context, payload) => {
    const res = await retrieveCredentialsApi.retrieveCredentialsFinish(payload)
    return res
}

/** retrieve credentials
@return { promise } - retrieve credentials
*/
export const retrieveCredentialsTokenResend = async (context, payload) => {
    const res = await retrieveCredentialsApi.retrieveCredentialsTokenResend(payload)
    return res
}
